<div class="example-questions-wrapper">
    <app-example-question
        *ngFor="let question of this.getExampleQuestions()"
        [question]="question"
        (click)="this.onExampleQuestionClicked(question)">
    </app-example-question>
</div>